import { styled, Breakpoints, ThemeDefinition } from '@vw-marketing/us-components';

export const StyledCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.size.static300};
  padding-bottom: ${({ theme }) => theme.size.static250};
  width: 100%;
`;

export const StyledVehicleContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static250};
  margin-top: 13.5%;
  width: 100%;
`;

export const StyledAwardLogoContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 53px;

  > .award-logo {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 500ms ease-in;

    img {
      max-height: 40px;
      max-width: 168px;
      width: auto;
    }
  }

  .span-text:hover {
    background: ${({ theme }: { theme: ThemeDefinition }) => theme.colors.button.primary.hover};
    color: ${({ theme }: { theme: ThemeDefinition }) => theme.colors.content.primary};
  }
`;

export const StyledVehicleInformation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.size.static150};
  width: 100%;
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.size.static150};
  padding: ${({ theme }) => theme.size.static250} ${({ theme }) => theme.size.grid001};
  width: 100%;
  @media (min-width: ${Breakpoints.b960}px) {
    padding: ${({ theme }) => theme.size.static250} 2.8vw;
  }
  @media (min-width: ${Breakpoints.b1280}px) {
    padding: ${({ theme }) => theme.size.static250} 1.4vw;
  }
  & [class^='StyledButton-'],
  & [class*=' StyledButton-'] {
    padding: 4px;
  }
`;

export const StyledPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;

  .span-text:hover {
    background: ${({ theme }: { theme: ThemeDefinition }) => theme.colors.button.primary.hover};
    color: ${({ theme }: { theme: ThemeDefinition }) => theme.colors.content.primary};
  }
`;
